import React, { useState } from 'react';
import './Saved.css';

function Saved() {
  const [savedListings] = useState([
    {
      id: 1,
      title: 'Cozy Apartment in SF',
      location: 'San Francisco, CA',
      price: 2500,
      beds: 1,
      baths: 1,
      photo: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=500'
    },
    {
      id: 2,
      title: 'Modern Condo in NYC',
      location: 'New York, NY',
      price: 3500,
      beds: 2,
      baths: 2,
      photo: 'https://images.unsplash.com/photo-1545324418-cc1a9f6bb8b1?w=500'
    }
  ]);

  const handleRemove = (id) => {
    alert(`Removed listing ${id} from saved`);
  };

  return (
    <div className="saved-container">
      <div className="saved-header">
        <h1>❤️ Saved Listings</h1>
        <p>{savedListings.length} properties saved</p>
      </div>

      {savedListings.length === 0 ? (
        <div className="empty-state">
          <p>You haven't saved any listings yet.</p>
          <button className="browse-btn">Start Browsing</button>
        </div>
      ) : (
        <div className="saved-grid">
          {savedListings.map(listing => (
            <div key={listing.id} className="saved-card">
              <div className="saved-image">
                <img src={listing.photo} alt={listing.title} />
                <button 
                  onClick={() => handleRemove(listing.id)}
                  className="remove-btn"
                  title="Remove from saved"
                >
                  ❤️
                </button>
              </div>
              <div className="saved-info">
                <h3>{listing.title}</h3>
                <p className="location">{listing.location}</p>
                <div className="specs">
                  <span>🛏️ {listing.beds} bed</span>
                  <span>🚿 {listing.baths} bath</span>
                </div>
                <p className="price">${listing.price}/month</p>
                <button className="view-btn">View Details</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Saved;
